module.exports = __webpack_public_path__ + "static/media/icon-toller.5031bc54.svg";